import { render, staticRenderFns } from "./StepTwoSMS.vue?vue&type=template&id=690e0974&lang=pug"
import script from "./StepTwoSMS.vue?vue&type=script&lang=ts"
export * from "./StepTwoSMS.vue?vue&type=script&lang=ts"
import style0 from "./StepTwoSMS.vue?vue&type=style&index=0&id=690e0974&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports